<div>
  <h2 style="margin-right: auto;">
    {{'SanlidaWorldRanking' | transloco}}
  </h2>
  <ng-container *ngIf="(comboCategories.loadingRef === false && rangeDate)">
  <lib-filters-component *ngIf="rangeDate && filterInfo && filterInfo.length>0" [filters_options]="filterInfo"></lib-filters-component>
  <ng-template #noData>
    <div class="status-message status-message--info">{{'No_data_available' | transloco}}</div>

  </ng-template>
  <ng-container *ngIf="loading === false">
  <div  #chart  *ngIf="chartData.length > 0;else noData"  style="width:100%; height: 425px;">
    <ng-container *ngIf="chartData as chartDataTmp">
    <app-custom-line-chart
      #chartSelect
      [yScaleMax]="1"
      [yScaleMin]="lowestWorldRanking"
      [yAxisTicks]="chartYPoints"
      [yAxisTickFormatting]="formatYAxis"
      [autoScale]="true"
      (window:resize)="onResize($event)"
      [timeline]="true"
      [xAxis]="true"
      [yAxis]="true"
      [showXAxisLabel]="true"
      [showYAxisLabel]="true"
      [roundDomains]="true"
      [scheme]="customColors"
      [view]="view"
      [results]="chartDataTmp" >
    </app-custom-line-chart>
  </ng-container>
  </div>
  </ng-container>

  <div class="position" *ngIf="maxRanking || actualRanking">
    <div class="box margin"  >
      <div class="description uppertext-black-no-viewport"><div>{{'current_ranking' | transloco}} </div>
      <div class="date" *ngIf="actualRanking;">{{' ('}}{{(actualRanking.RnkDtIssued | date : 'd MMMM yyyy')}}{{')'}}

    </div>
    <ng-template  #noRanking>
      <span class="score uppertext-black-no-viewport">-</span>
    </ng-template>
      </div>
      <span *ngIf="actualRanking; else noRanking" class="score uppertext-black-no-viewport">{{actualRanking.Rnk}}</span>
      </div>


      <div class="box" >
        <div  class="description uppertext-black-no-viewport"><div>{{'career_best_ranking' | transloco}}

        </div>
        <div *ngIf="maxRanking" class="date">{{' ('}}{{(maxRanking.RnkDtIssued | date : 'd MMMM yyyy')}}{{')'}}
        </div>
        </div>
        <span *ngIf="maxRanking;else noRanking" class="score uppertext-black-no-viewport">{{maxRanking.Rnk}}</span>
        </div>
      </div>
  </ng-container>
</div>
